export const paymentTermEn = {
  Dashboard: `Dashboard`,
  catalog: `Catalog`,
  payment_terms: `Payment Terms`,
  payment_term: `Payment Term`,
  add_payment_term: `Add Payment Term`,
  edit_payment_term: `Edit Payment Term`,
  delete_payment_term: `Delete Payment Term`,
  delete_payment_term_description: `Are you sure you want to delete this payment term? This action cannot be undone.`,
  code: `Code`,
  name: `Name`,
  due_days: `Due Days`,
  early_payment_discount_percentage: `Early Payment Discount (%)`,
  early_payment_discount_days: `Early Payment Discount Days`,
  actions: `Actions`,
  search: `Search`,
  search_placeholder: `Search by code or name`,
  filter_payment_terms: `Filter Payment Terms`,
  filter_payment_terms_subtitle: `Narrow down the payment terms list`,
  edit: `Edit`,
  delete: `Delete`,
  cancel: `Cancel`,
  add: `Add`,
  update: `Update`,
  code_required: `Code is required`,
  name_required: `Name is required`,
  due_days_required: `Due days is required`,
  must_be_whole_number: `Must be a whole number`,
  must_be_zero_or_more: `Must be 0 or more`,
  discount_percentage_required: `Discount percentage is required`,
  discount_percentage_range: `Discount percentage must be between 0 and 100`,
  discount_days_required: `Discount days is required`,
  no_payment_terms_found: `No payment terms found`,
  payment_term_created_successfully: `Payment term created successfully`,
  payment_term_updated_successfully: `Payment term updated successfully`,
  payment_term_deleted_successfully: `Payment term deleted successfully`,
  something_went_wrong: `Something went wrong`,
  organization_not_found: `Organization not found for the current user`,
  payment_term_code_required: `Payment term code is required`,
  payment_term_name_required: `Payment term name is required`,
  payment_term_code_duplicate: `A payment term with this code already exists`,
  payment_term_due_days_invalid: `Due days must be 0 or more`,
  payment_term_discount_percentage_invalid: `Discount percentage must be between 0 and 100`,
  payment_term_discount_days_invalid: `Discount days must be greater than 0 and within due days when a discount is set, or 0 when there is no discount`,
  payment_term_not_found: `Payment term not found`,
  not_allowed_to_update_payment_term: `You are not allowed to update this payment term`,
  not_allowed_to_delete_payment_term: `You are not allowed to delete this payment term`,
  payment_term_listing_max_100_allowed: `A maximum of 100 payment terms can be listed per page`,
};
